module.exports = __webpack_public_path__ + "static/media/myLocation.a44854ad.png";